import img1 from "../../../../src/pages/requirements/502.3.1/thumbnail-haac-swuiobject-swdialogbox.gif";
import * as React from 'react';
export default {
  img1,
  React
};